module.exports = __webpack_public_path__ + "static/banner-johannie-mobile-1623d80e5c8199df935e418efeba7fc7.jpg";